import { lazy } from 'react'
import { Route, Navigate } from 'react-router-dom'
import { StoreLayout } from '@/store/components/layout/StoreLayout'
import { StoreLaunchGate } from '@/store/components/layout/StoreLaunchGate'
import { LaunchPage } from '@/store/pages/LaunchPage'
import { HomePage } from '@/store/pages/HomePage'

const ShopPage = lazy(() =>
  import('@/store/pages/ShopPage').then((m) => ({ default: m.ShopPage }))
)
const ProductDetailPage = lazy(() =>
  import('@/store/pages/ProductDetailPage').then((m) => ({
    default: m.ProductDetailPage,
  }))
)
const CartPage = lazy(() =>
  import('@/store/pages/CartPage').then((m) => ({ default: m.CartPage }))
)
const CheckoutPage = lazy(() =>
  import('@/store/pages/CheckoutPage').then((m) => ({ default: m.CheckoutPage }))
)
const OrderSuccessPage = lazy(() =>
  import('@/store/pages/OrderSuccessPage').then((m) => ({
    default: m.OrderSuccessPage,
  }))
)
const OrdersPage = lazy(() =>
  import('@/store/pages/OrdersPage').then((m) => ({ default: m.OrdersPage }))
)
const StoreOrderDetailPage = lazy(() =>
  import('@/store/pages/StoreOrderDetailPage').then((m) => ({
    default: m.StoreOrderDetailPage,
  }))
)
const WishlistPage = lazy(() =>
  import('@/store/pages/WishlistPage').then((m) => ({ default: m.WishlistPage }))
)
const ReturnRefundPolicyPage = lazy(() =>
  import('@/store/pages/ReturnRefundPolicyPage').then((m) => ({
    default: m.ReturnRefundPolicyPage,
  }))
)
const TermsAndConditionsPage = lazy(() =>
  import('@/store/pages/TermsAndConditionsPage').then((m) => ({
    default: m.TermsAndConditionsPage,
  }))
)
const PrivacyPolicyPage = lazy(() =>
  import('@/store/pages/PrivacyPolicyPage').then((m) => ({
    default: m.PrivacyPolicyPage,
  }))
)
const ShippingPolicyPage = lazy(() =>
  import('@/store/pages/ShippingPolicyPage').then((m) => ({
    default: m.ShippingPolicyPage,
  }))
)
const AboutPage = lazy(() =>
  import('@/store/pages/AboutPage').then((m) => ({ default: m.AboutPage }))
)
const ContactPage = lazy(() =>
  import('@/store/pages/ContactPage').then((m) => ({ default: m.ContactPage }))
)
const SearchPage = lazy(() =>
  import('@/store/pages/SearchPage').then((m) => ({ default: m.SearchPage }))
)
const NotesPage = lazy(() =>
  import('@/store/pages/NotesPage').then((m) => ({ default: m.NotesPage }))
)

export function StoreRoutes() {
  return (
    <>
      <Route path="launch" element={<LaunchPage />} />
      <Route element={<StoreLaunchGate />}>
        <Route element={<StoreLayout />}>
          <Route index element={<HomePage />} />
          <Route path="search" element={<SearchPage />} />
          <Route path="notes" element={<NotesPage />} />
          <Route path="shop" element={<ShopPage />} />
          <Route path="shop/:id" element={<ProductDetailPage />} />
          <Route path="cart" element={<CartPage />} />
          <Route path="checkout" element={<CheckoutPage />} />
          <Route path="order-success" element={<OrderSuccessPage />} />
          <Route path="orders" element={<OrdersPage />} />
          <Route path="orders/:id" element={<StoreOrderDetailPage />} />
          <Route path="wishlist" element={<WishlistPage />} />
          <Route
            path="return-refund-policy"
            element={<ReturnRefundPolicyPage />}
          />
          <Route
            path="terms-and-conditions"
            element={<TermsAndConditionsPage />}
          />
          <Route path="privacy-policy" element={<PrivacyPolicyPage />} />
          <Route path="about-us" element={<AboutPage />} />
          <Route path="shipping-policy" element={<ShippingPolicyPage />} />
          <Route path="contact" element={<ContactPage />} />
          <Route path="profile" element={<Navigate to="/" replace />} />
          <Route path="auth/*" element={<Navigate to="/" replace />} />
        </Route>
      </Route>
    </>
  )
}
